import { render, staticRenderFns } from "./FilePaste.vue?vue&type=template&id=0679b75a&scoped=true&"
import script from "./FilePaste.vue?vue&type=script&lang=js&"
export * from "./FilePaste.vue?vue&type=script&lang=js&"
import style0 from "./FilePaste.vue?vue&type=style&index=0&id=0679b75a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0679b75a",
  null
  
)

export default component.exports